import { createContext } from 'react';
import type { IFeatureToggles } from '../types';

export const FeatureTogglesContext = createContext<IFeatureToggles>({});
